import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { API_URL } from '../../utils/axiosConfig';
import { useAuth } from '../../contexts/AuthContext';
import EmailNotVerifiedBanner from '../auth/EmailNotVerifiedBanner';

function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEmailBanner, setShowEmailBanner] = useState(false);
  const [unverifiedEmail, setUnverifiedEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/login`, { email, password });
      login(response.data.user, response.data.token);
      // Redirect based on role
      navigate(response.data.user.role === 'admin' ? '/admin' : '/player');
    } catch (error) {
      const errorData = error.response?.data;

      // Vérifier si c'est une erreur d'email non vérifié
      if (errorData?.emailNotVerified) {
        setShowEmailBanner(true);
        setUnverifiedEmail(errorData.userEmail || email);
        setError(''); // Clear any previous errors
      } else {
        setShowEmailBanner(false); // Hide banner for other errors
        setError(errorData?.error || 'Erreur de connexion');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">Connexion</h2>

        {showEmailBanner && (
          <EmailNotVerifiedBanner
            email={unverifiedEmail}
            onClose={() => setShowEmailBanner(false)}
          />
        )}

        {error && (
          <div className="bg-red-100 border border-red-400 text-blue-900 px-3 py-2 rounded mb-3 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-900 text-white py-2 text-sm rounded-lg hover:bg-blue-950 transition font-semibold disabled:bg-gray-400"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="mt-3 text-center">
          <button
            onClick={() => navigate('/forgot-password')}
            className="text-blue-900 hover:underline text-sm"
          >
            Mot de passe oublié ?
          </button>
        </div>

        <div className="mt-3 text-center">
          <p className="text-gray-700 text-sm">
            Pas de compte ?{' '}
            <button
              onClick={() => navigate('/register')}
              className="text-blue-900 hover:underline font-semibold"
            >
              S'inscrire
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
